<template>
  <div class="progressBar">
    <div class="bg"></div>
    <div :style="{width:progressVal+'%'}" class="progress"></div>
    <img :style="{left:progressVal+'%'}" class="fire" src="../../assets/images/DiwaliFestival/fire.svg" alt="">

    <div v-for="(item,index) in rewardFormulas" :style="{left:item.percentage+'%'}" :key="language + index"
         class="node">
      <div class="num">{{ item.Amount }}</div>
      <div
        :class="item.percentage > 50 ? (language === 'IN' ? 'reachTipMax' : 'reachTipMaxEN') : (language === 'IN' ? 'reachTip' : 'reachTipEN')"
        v-if="item.showTip">
        <span v-if="language === 'IN'">यहाँ तक पहुँचें, कल ₹{{ item.Reward }} पुरस्कार प्राप्त कर सकते हैं।</span>
        <span v-else>Reach node.Get₹ {{ item.Reward }} tomorrow</span>
      </div>
      <div class="arrow" v-if="item.showTip"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'progressBar',
  props: ['data'],
  data () {
    return {
      language: localStorage.getItem('locale'),
      progressVal: 40,
      rewardFormulas: [
        // {
        //   'Amount': 500,
        //   'Reward': 7,
        //   percentage: 0,
        //   showTip: false
        // },
        // {
        //   'Amount': 2000,
        //   'Reward': 177,
        //   percentage: 0,
        //   showTip: false
        // },
        // {
        //   'Amount': 5000,
        //   'Reward': 177,
        //   percentage: 0,
        //   showTip: false
        // },
        // {
        //   'Amount': 10000,
        //   'Reward': 777,
        //   percentage: 0,
        //   showTip: false
        // }
      ]
    }
  },
  watch: {
    '$store.state.locale': function (val) {
      this.language = val
    },
    'data': function (val) {
      console.log('vavvvvvvvvvvvlue', val)
      if (val) {
        this.rewardFormulas = val.RewardFormulas
        this.calculatePercentages(val.TodayAmount)
        console.log(this.rewardFormulas)
      }
    }
  },
  mounted () {
    if (this.data) {
      this.rewardFormulas = this.data.RewardFormulas
      this.calculatePercentages(this.data.TodayAmount)
      console.log(this.rewardFormulas)
    }
  },
  methods: {
    calculatePercentages (Amount) {
      // 找到最大的Amount值
      const maxAmount = Math.max(...this.rewardFormulas.map(item => item.Amount))
      this.progressVal = ((Amount / maxAmount) * 100).toFixed(2)
      // 遍历每个公式，计算百分比
      this.rewardFormulas.forEach(item => {
        // 计算当前Amount占最大Amount的百分比
        item.percentage = (item.Amount / maxAmount) * 100
      })
      try {
        this.rewardFormulas.forEach(item => {
          // 计算当前Amount占最大Amount的百分比
          if (item.percentage > this.progressVal) {
            item.showTip = true
            throw new Error('')
          }
        })
      } catch (e) {
      }

      console.log(this.rewardFormulas)
    }
  }
}
</script>
<style scoped lang="less">
.progressBar {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
  //border:1px solid red;
  .bg {
    width: 100%;
    height: 1.8vw;
    border-radius: 2vw;
    background: rgba(0, 0, 0, .5);
  }

  .progress {
    //width: 100%;
    height: 1.8vw;
    border-radius: 2vw;
    background-image: linear-gradient(to right, #E1FF5B 0%, #FFF540 100%);
    position: absolute;
  }

  .fire {
    margin-left: -2.7vw;
    margin-top: -1.5vw;
    position: absolute;
    z-index: 1;
    width: 5.55vw;
    height: auto;
  }

  .node {
    height: 1.8vw;
    width: 1.8vw;
    border-radius: 5vw;
    background: #FFF690;
    //background: #FFF690;
    //margin-top: -0.12vw;
    position: absolute;

    .num {
      position: absolute;
      font-size: 3vw;
      font-weight: 700;
      color: #B7B58E;
      left: -2.5vw;
      top: 2vw;
    }

    .reachTip {
      position: absolute;
      //height: 7vw;
      width: 40vw;
      background: #F1FFC2;
      font-size: 3vw;
      white-space: wrap; /* 防止文本换行 */
      //line-height: 7vw;
      padding: 1vw;
      border-radius: 1vw;
      color: #000;
      top: -12.8vw;
      left: -5.8vw;
    }

    .reachTipMax {
      position: absolute;
      //height: 7vw;
      width: 40vw;
      background: #F1FFC2;
      font-size: 3vw;
      white-space: wrap;
      //line-height: 7vw;
      padding: 1vw;
      border-radius: 1vw;
      top: -12.8vw;
      left: -34.8vw;
      color: #000;
    }

    .reachTipEN {
      position: absolute;
      //height: 7vw;
      //width: 40vw;
      background: #F1FFC2;
      font-size: 3vw;
      white-space: nowrap; /* 防止文本换行 */
      //line-height: 7vw;
      padding: 1vw;
      border-radius: 1vw;
      color: #000;
      top: -7.8vw;
      left: -5.8vw;
    }

    .reachTipMaxEN {
      position: absolute;
      //height: 7vw;
      background: #F1FFC2;
      font-size: 3vw;
      white-space: nowrap;
      //line-height: 7vw;
      padding: 1vw;
      border-radius: 1vw;
      top: -7.8vw;
      left: -34.8vw;
      color: #000;
    }

    .arrow {
      transform: rotate(45deg);
      position: absolute;
      height: 2vw;
      width: 2vw;
      background: #F1FFC2;
      top: -4vw;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DiwaliFestivalProgressBar/index.vue